import {
  Box, Grid, makeStyles, Typography, Hidden,
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import StoryContext from '../../contexts/StoryContext';
import states from '../../modules/states';
import QuestionHeaderBox from '../QuestionHeaderBox';

function Q1Header() {
  const { stateCode } = useParams();
  const { primaryColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    question: {
      marginTop: theme.spacing(2),
      color: primaryColor,
    },
    definitionBox: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      backgroundColor: `${primaryColor} !important`,
      color: '#fff !important',
    },
    questionBox: {
      padding: theme.spacing(2),
      textAlign: 'center',
    },
    headline: {
      fontWeight: 'bold',
    },
  }))();

  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      spacing={4}
    >
      <Grid item xs={12}>
        <QuestionHeaderBox color={primaryColor}>
          {/* <HelpIcon style={{ color: primaryColor, fontSize: 60 }} align="center" /> */}
          <Typography variant="h3" component="h2" align="center" className={classes.question} gutterBottom>
            In {states[stateCode.toUpperCase()]}, are children at risk of lead exposure?
          </Typography>
          <Hidden only="xs">
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item xs={5}>
                <Box borderRadius={8} className={classes.definitionBox}>
                  <Typography variant="h5" align="center">High-risk locations</Typography>
                  <WarningIcon style={{ fontSize: 40, color: '#fff' }} />
                </Box>
              </Grid>
              <Grid item xs={1}>
                <Typography variant="body1" align="center" style={{ color: primaryColor, fontSize: 60 }}>=</Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography variant="body1" align="left">
                  Child care programs:
                </Typography>
                <ul style={{ marginBlockStart: 0 }}>
                  <li>
                    <Typography variant="body1" align="left">Within 1 mile of a Toxics Release Inventory Site, and/or</Typography>
                  </li>
                  <li>
                    <Typography variant="body1" align="left">In the same zip code as a Superfund Site</Typography>
                  </li>
                </ul>
              </Grid>
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Typography variant="body1" align="center" style={{ color: primaryColor }}>
              The high-risk child care providers are located within 1 mile of a toxic release inventory site, and/or in the same zip code as a superfund site.
            </Typography>
          </Hidden>
          <Typography variant="body1" align="center" style={{ marginTop: 10 }} gutterBottom>
            Lead is a neurotoxin that affects young children’s brain development and can lead to long-term problems with learning and behavior. Industrial sites can release lead and other dangerous chemicals into the environment, putting children in nearby child care programs at higher risk for lead exposure.
          </Typography>
          <Typography variant="body1" align="center" style={{ marginTop: 10 }} gutterBottom>
            Children of color and children from families with low income face a disproportionately high risk of lead exposure. These families are also more likely to rely on child care subsidies to access affordable care, giving them fewer child care choices than other families have.
          </Typography>
        </QuestionHeaderBox>
      </Grid>
    </Grid>
  );
}

export default Q1Header;
